












































































































import { Component, Vue, Inject, Prop } from "vue-property-decorator";
import { TranslateResult } from "vue-i18n";
import { FromStore } from "@abaco/web-common/src/app";
import DashboardModule, { MODULE_ID } from "../..";
import { MenuItem } from "@abaco/web-common/src/app/Application";
import SSOModule from "@abaco/sso-web-module/src/abaco-module";

@Component({
    components: {}
})
export default class HeaderFerreroMainButton extends Vue {
    @Inject() i18n!: (key: string, values?: unknown) => TranslateResult;
    @Inject(MODULE_ID) DashboardModule!: DashboardModule;
    @Inject(SSOModule.MODULE_ID) ssoModule!: SSOModule;

    @Prop() homePage!: MenuItem;
}
